declare const __APP_BUILD__: string
import { Routes, Route, Navigate } from 'react-router-dom'
import { SiteNav } from './components/SiteNav'
import { DashboardPage } from './pages/DashboardPage'
import { CampaignPage } from './pages/CampaignPage'
import { CharacterSheetPage } from './pages/CharacterSheetPage'
import { CharacterCreationPage } from './pages/CharacterCreationPage'
import { ActionHistoryPage } from './pages/ActionHistoryPage'
import { NPCGeneratorPage } from './pages/NPCGeneratorPage'

function App() {
  return (
    <>
    <SiteNav />
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/campaign/:id" element={<CampaignPage />} />
      <Route path="/character/:id" element={<CharacterSheetPage />} />
      <Route path="/character/:id/history" element={<ActionHistoryPage />} />
      <Route path="/campaign/:id/generate-npc" element={<NPCGeneratorPage />} />
      <Route path="/character/new" element={<CharacterCreationPage />} />
    </Routes>
    <footer className="text-center text-ink-light/40 text-[10px] py-2 mt-4">
      Build {__APP_BUILD__}
    </footer>
    </>
  )
}

export default App
